// redux/filter/filter.reducer.js
import FilterType from "./filter.type";

const INITIAL_STATE = {
  status: [],
  priorityScope: null,
  time: null,
  timeZone: {},
  user: null,
};

const filterReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FilterType.SET_FILTER_NULL:
      return {
        ...state,
        status: [],
        priorityScope: null,
        time: null,
        user: null,
      };

    case FilterType.TOGGLE_STATUS: {
      const { value, scope } = action.payload;

      const selected =
        state.priorityScope === scope
          ? state.status || []
          : [];

      return {
        ...state,
        priorityScope: scope,
        status: selected.includes(value)
          ? selected.filter((item) => item !== value)
          : [...selected, value],
      };
    }

    case FilterType.TOGGLE_TIME:
      return {
        ...state,
        time: state.time === action.payload ? null : action.payload,
      };

    case FilterType.SET_TIME_ZONE: {
      const { taskId, zone } = action.payload;

      return {
        ...state,
        timeZone: {
          ...state.timeZone,
          [taskId]: { zone },
        },
      };
    }

    case FilterType.SET_USER_FILTER:
      return {
        ...state,
        user: action.payload,
      };

    case FilterType.CLEAR_USER:
      return {
        ...state,
        user: null,
      };

    default:
      return state;
  }
};

export default filterReducer;